// extracted by mini-css-extract-plugin
export default {"ConfirmationContainer":"ConfirmationRegistrationMail_ConfirmationContainer__e0raK","Confirmation":"ConfirmationRegistrationMail_Confirmation__MKTtF"};